<template>
  <b-overlay :show="show">
    <div class="my-register-page" style="font-size: 13px">
      <div class="my-container">
        <!-- Collapse A: 1-7 punkts (inspection info, read-only) -->
        <div class="collapseCard mb-3 mt-4">
          <div class="collapseHeader" v-b-toggle.collapse-info>
            <h5 class="styleText mb-0">{{ $t("inspectionMainInfo") }}</h5>
            <b-icon
              :icon="infoVisible ? 'chevron-up' : 'chevron-down'"
              font-scale="1.2"
            ></b-icon>
          </div>
          <b-collapse id="collapse-info" v-model="infoVisible">
            <div class="collapseBody">
        <div class="cardStyleEdit mb-3 pt-2">
          <b-row>
            <b-col>
              <h5 class="styleText">1 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="6">
              <custom-input
                disabled
                :placeholder="$t('orderCode')"
                v-model="Request.orderCode"
                :label="$t('orderCode')"
              ></custom-input>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">2 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col cols="12" sm="6" md="6" class="mb-3">
              <v-select
                disabled
                :placeholder="$t('orderedOrganization')"
                class="my-select"
                :options="ParentList"
                :reduce="(item) => item.value"
                label="text"
                v-model="Request.orderedOrganizationId"
                @input="ChangeOrganization"
              ></v-select>
            </b-col>
            <b-col cols="12" sm="6" md="6" class="mb-3">
              <v-select
                disabled
                :placeholder="$t('inspectionOrganization')"
                class="my-select"
                :options="OrganizationList"
                :reduce="(item) => item.value"
                label="text"
                v-model="Request.inspectionOrganizationId"
                @input="ChangeInspectionOrganization"
              ></v-select>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <custom-input-white
                disabled
                :placeholder="$t('inspectionOrganizationAddres')"
                v-model="Request.contractorAddres"
                :label="$t('inspectionOrganizationAddres')"
              ></custom-input-white>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <custom-input-white
                disabled
                :placeholder="$t('inspectionOrganizationName')"
                v-model="Request.inspectionOrganizationName"
                :label="$t('inspectionOrganizationName')"
              ></custom-input-white>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="6">
              <custom-input-white
                disabled
                :placeholder="$t('inspectionOrganizationPostalAddres')"
                v-model="Request.inspectionOrganizationAddres"
                :label="$t('inspectionOrganizationPostalAddres')"
              ></custom-input-white>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <custom-input-white
                disabled
                :placeholder="$t('inspectionOrganizationCeo')"
                v-model="Request.inspectionOrganizationCeo"
                :label="$t('inspectionOrganizationCeo')"
              ></custom-input-white>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col class="mt-2 mb-2" style="text-align: left">
              <h5 class="styleText">3 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table-simple bordered responsive>
                <b-tbody>
                  <b-tr variant="primary">
                    <b-td colspan="6" class="text-center">
                      <span style="font-size: 18px; font-weight: bold">{{
                        $t("inspectors")
                      }}</span>
                    </b-td>
                  </b-tr>
                  <b-tr variant="primary">
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("employeeName") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("dutyNumberInspector1") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("dutyExpirationInspector") }}
                      </span>
                    </b-td>
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("certificateNumber1") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("certificateExpiration1") }}
                      </span>
                    </b-td>
                  </b-tr>
                  <b-tr
                    style="background-color: white"
                    v-for="(item, index) in Request.inspectors"
                    :key="index"
                  >
                    <b-td>
                      {{ item.fullName }}
                    </b-td>
                    <b-td class="text-right">
                      <p>{{ item.dutyNumber }}</p>
                    </b-td>
                    <b-td>
                      <p>{{ item.dutyExpiration }}</p>
                    </b-td>
                    <b-td class="text-right">
                      <p>{{ item.certificateNumber }}</p>
                    </b-td>
                    <b-td>
                      <p>{{ item.certificateExpiration }}</p>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col class="mt-2 mb-2" style="text-align: left">
              <h5 class="styleText">4 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table-simple bordered responsive>
                <b-tbody>
                  <b-tr variant="primary">
                    <b-td colspan="10" class="text-center">
                      <span style="font-size: 18px; font-weight: bold">{{
                        $t("involvedInspectors")
                      }}</span>
                    </b-td>
                  </b-tr>
                  <b-tr variant="primary">
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("organizationName") }}
                      </span>
                    </b-td>
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("addressEmail") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("inspectorFullName") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("dutyNumberInspector") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("dutyExpirationInspector") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("dutyIssuingOrganization") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("certificateNumber") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("certificateIssuingOrganization") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("certificateExpiration") }}
                      </span>
                    </b-td>
                  </b-tr>
                  <b-tr
                    style="background-color: white"
                    v-for="(item, index) in Request.involvedInspectors"
                    :key="index"
                  >
                    <b-td>
                      {{ item.organizationName }}
                    </b-td>

                    <b-td>
                      {{ item.address }}
                    </b-td>
                    <b-td>
                      {{ item.inspectorFullName }}
                    </b-td>

                    <b-td>
                      {{ item.dutyNumber }}
                    </b-td>
                    <b-td>
                      {{ item.dutyExpiration }}
                    </b-td>

                    <b-td>
                      {{ item.dutyIssuingOrganization }}
                    </b-td>
                    <b-td>
                      {{ item.certificateNumber }}
                    </b-td>

                    <b-td>
                      {{ item.certificateIssuingOrganization }}
                    </b-td>
                    <b-td>
                      {{ item.certificateExpiration }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-table-simple bordered responsive>
                <b-tbody>
                  <b-tr variant="primary">
                    <b-td colspan="8" class="text-center">
                      <span style="font-size: 18px; font-weight: bold">{{
                        $t("InvolvedAuditors")
                      }}</span>
                    </b-td>
                  </b-tr>
                  <b-tr variant="primary">
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("organizationNameAuditor") }}
                      </span>
                    </b-td>
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("licenseDate") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("licenseNumber") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("licenseExpiration") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("auditorFullName") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("contractNumber") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("contractExpiration") }}
                      </span>
                    </b-td>
                  </b-tr>
                  <b-tr
                    style="background-color: white"
                    v-for="(item, index) in Request.involvedAuditors"
                    :key="index"
                  >
                    <b-td>
                      {{ item.organizationName }}
                    </b-td>

                    <b-td>
                      {{ item.licenseDate }}
                    </b-td>
                    <b-td>
                      {{ item.licenseNumber }}
                    </b-td>
                    <b-td>
                      {{ item.licenseExpiration }}
                    </b-td>
                    <b-td>
                      {{ item.auditorFullName }}
                    </b-td>
                    <b-td>
                      {{ item.contractNumber }}
                    </b-td>
                    <b-td>
                      {{ item.contractExpiration }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-table-simple bordered responsive>
                <b-tbody>
                  <b-tr variant="primary">
                    <b-td colspan="5" class="text-center">
                      <span style="font-size: 18px; font-weight: bold">{{
                        $t("specialists")
                      }}</span>
                    </b-td>
                  </b-tr>
                  <b-tr variant="primary">
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("inspectorsName") }}
                      </span>
                    </b-td>
                    <b-td>
                      <span style="font-size: 14px; font-weight: bold">
                        {{ $t("contractNumber") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("identificationDocument") }}
                      </span>
                    </b-td>
                    <b-td
                      ><span style="font-size: 14px; font-weight: bold">
                        {{ $t("contractExpiration") }}
                      </span>
                    </b-td>
                  </b-tr>
                  <b-tr
                    style="background-color: white"
                    v-for="(item, index) in Request.specialists"
                    :key="index"
                  >
                    <b-td>
                      {{ item.fullName }}
                    </b-td>

                    <b-td>
                      {{ item.contractNumber }}
                    </b-td>
                    <b-td>
                      {{ item.identificationDocument }}
                    </b-td>

                    <b-td>
                      {{ item.contractExpiration }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">5 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="4" class="mb-3">
              <custom-input-white
                class="inputStyle"
                disabled
                v-mask="'###-###-###'"
                :placeholder="$t('docNumber5')"
                v-model="Request.docNumber"
                :label="$t('docNumber5')"
              ></custom-input-white>
            </b-col>
            <b-col cols="12" sm="12" md="4" class="mb-3">
              <custom-input-white
                class="inputStyle"
                disabled
                :placeholder="$t('orderNumber5')"
                v-model="Request.orderNumber"
                :label="$t('orderNumber5')"
              ></custom-input-white>
            </b-col>
            <b-col cols="12" sm="12" md="4" class="mb-3">
              <custom-date-picker
                disabled
                :label="$t('orderDate5')"
                placeholder="00.00.0000"
                v-model="Request.orderDate"
              ></custom-date-picker>
            </b-col>
            <b-col cols="12" sm="12" md="12">
              <custom-textarea
                class="inputStyle"
                disabled
                :placeholder="$t('criminalCaseInfo')"
                v-model="Request.criminalCaseInfo"
                :label="$t('criminalCaseInfo')"
              ></custom-textarea>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">6 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="12">
              <v-select
                disabled
                multiple
                :placeholder="$t('controlFunctions')"
                class="my-select"
                :options="ControlFunctionList"
                :reduce="(item) => item.value"
                label="text"
                v-model="Request.controlFunctionNames"
                @input="ControlFunctionsChange"
              ></v-select>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">7 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="4">
              <custom-date-picker
                disabled
                :label="$t('startDate')"
                placeholder="00.00.0000"
                v-model="Request.startDate"
              ></custom-date-picker>
            </b-col>

            <b-col cols="12" sm="12" md="4">
              <custom-date-picker
                disabled
                :label="$t('endDate')"
                placeholder="00.00.0000"
                v-model="Request.endDate"
              ></custom-date-picker>
            </b-col>

            <b-col cols="12" sm="12" md="4">
              <custom-input-white
                disabled
                placeholder="0"
                v-model="Request.checkDaysNumber"
                :label="$t('checkDaysNumber')"
              ></custom-input-white>
            </b-col>
          </b-row>
        </div>
            </div>
          </b-collapse>
        </div>
        <!-- Collapse B: 8-12 punkts + rating (read-only) -->
        <div class="collapseCard mb-3">
          <div class="collapseHeader" v-b-toggle.collapse-fill>
            <h5 class="styleText mb-0">{{ $t("contractorFillPart") }}</h5>
            <b-icon
              :icon="fillVisible ? 'chevron-up' : 'chevron-down'"
              font-scale="1.2"
            ></b-icon>
          </div>
          <b-collapse id="collapse-fill" v-model="fillVisible">
            <div class="collapseBody">
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">8 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="4">
              <custom-date-picker
                disabled
                :label="$t('contractorStartDate')"
                placeholder="00.00.0000"
                v-model="Request.contractorStartDate"
              ></custom-date-picker>
            </b-col>

            <b-col cols="12" sm="12" md="4">
              <custom-date-picker
                disabled
                :label="$t('contractorEndDate')"
                placeholder="00.00.0000"
                v-model="Request.contractorEndDate"
              ></custom-date-picker>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">9 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="4">
              <custom-input-white
                disabled
                placeholder="0"
                v-model="Request.contractorCheckDaysNumber"
                :label="$t('ContractorCheckDaysNumber')"
              ></custom-input-white>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">10 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="12">
              <custom-textarea
                disabled
                :placeholder="$t('requestedDocuments')"
                v-model="Request.requestedDocuments"
                :label="$t('requestedDocuments')"
              ></custom-textarea>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">11 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="12">
              <custom-textarea
                disabled
                :placeholder="$t('takenMeasures')"
                v-model="Request.takenMeasures"
                :label="$t('takenMeasures')"
              ></custom-textarea>
            </b-col>
          </b-row>
        </div>
        <div class="cardStyleEdit mb-3">
          <b-row>
            <b-col>
              <h5 class="styleText">12 - {{ $t("punkt") }}</h5>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col cols="12" sm="12" md="12">
              <custom-textarea
                disabled
                :placeholder="$t('thirdPartyInfo')"
                v-model="Request.thirdPartyInfo"
                :label="$t('thirdPartyInfo')"
              ></custom-textarea>
            </b-col>
          </b-row>
        </div>
        <div class="rate-card mb-3">
          <div class="rate-card-head">
            <h5 class="rate-card-title">{{ $t("Rating") }}</h5>
            <span class="rate-card-hint">{{ $t("RatingStep2Hint") }}</span>
          </div>
          <div class="rate-card-body">
            <div class="rate-stars">
              <span
                v-for="n in 5"
                :key="n"
                class="rate-star"
                :class="{ filled: n <= (Request.rating || 0) }"
              >
                <b-icon icon="star-fill"></b-icon>
              </span>
              <strong class="rate-val">{{ Request.rating || 0 }} / 5</strong>
            </div>
            <textarea
              v-model="Request.ratingComment"
              class="rate-comment"
              disabled
              :placeholder="$t('InspectionCommentPh')"
            ></textarea>
          </div>
        </div>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import InspectionBookService from "@/services/inspectionbook.service";
import customDatePicker from "../../components/customDatePickerWhite.vue";
import customInput from "../../components/elements/customInput.vue";
import customInputWhite from "../../components/customInputWhite.vue";
import customSelect from "../../components/customSelectWhite.vue";
import vSelect from "vue-select";
import "bootstrap-vue/dist/bootstrap-vue.css";
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BBadge,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BOverlay,
  BFormRating,
  BModal,
  BLink,
} from "bootstrap-vue";
import customTextarea from "../../components/customTextareaWhite.vue";
import ControlFunctionService from "@/services/controlfunction.service";
import ManualService from "@/services/manual.service";
export default {
  data() {
    return {
      Request: {},
      ControlFunctionList: [],
      filter: {},
      show: false,
      ParentList: [],
      OrganizationList: [],
      infoVisible: false,
      fillVisible: true,
    };
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BBadge,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BOverlay,
    customDatePicker,
    customInput,
    BFormRating,
    customTextarea,
    vSelect,
    BModal,
    BLink,
    customInputWhite,
    customSelect,
  },
  created() {
    this.Refresh();

    ManualService.GetOrganizationAsSelectList("", false, true).then((res) => {
      this.ParentList = res.data;
    });
  },
  methods: {
    ChangeOrganization() {
      this.Request.inspectionOrganizationId = 0;
      this.Request.inspectionOrganizationName = "";
      ManualService.GetOrganizationAsSelectList(
        this.Request.orderedOrganizationId,
        false,
        true
      ).then((res) => {
        this.OrganizationList = res.data;
      });
    },
    ChangeInspectionOrganization() {
      this.Request.inspectionOrganizationName = "";
      if (!!this.Request.inspectionOrganizationId) {
        this.Request.inspectionOrganizationName = this.OrganizationList.filter(
          (item) => item.value === this.Request.inspectionOrganizationId
        )[0].text;
        ControlFunctionService.GetAsSelectList(
          this.Request.orderedOrganizationId
        ).then((res) => {
          this.ControlFunctionList = res.data;
        });
      }
    },
    ControlFunctionsChange() {},
    Refresh() {
      this.show = true;
      InspectionBookService.Get(this.$route.params.id)
        .then((res) => {
          this.Request = res.data;
          this.show = false;
          ManualService.GetOrganizationAsSelectList(
            this.Request.orderedOrganizationId,
            false,
            true
          ).then((res) => {
            this.OrganizationList = res.data;
          });
          if (!!this.Request.inspectionOrganizationId) {
            this.Request.inspectionOrganizationName = this.OrganizationList.filter(
              (item) => item.value === this.Request.inspectionOrganizationId
            )[0].text;
            ControlFunctionService.GetAsSelectList(
              this.Request.orderedOrganizationId
            ).then((res) => {
              this.ControlFunctionList = res.data;
            });
          }
        })
        .catch((error) => {
          this.makeToast(error.response.data, "error");
          this.show = false;
        });
    },
    back() {
      this.$router.go(-1);
    },
    makeToast(message, type) {
      var a = "";
      if (message.status == 500) {
        a = message.title;
      }
      if (message.status == 400) {
        var errors = Object.values(message.errors);
        var a = errors.map((el, item) => item + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style>
.backColor {
  background-color: #f3f1f1 !important;
}
.vs__dropdown-toggle {
  background-color: white !important;
}
.v-toast__item--Error {
  background-color: red;
}
.v-toast__item--success {
  background-color: green;
}
.cardStyleEdit {
  padding: 5px;
  background-color: #eaf2ff;
  border-radius: 5px;
}
.collapseCard {
  padding: 5px;
  background-color: #dbe7ff;
  border-radius: 5px;
}
.collapseHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 10px 8px;
  user-select: none;
}
.collapseBody {
  padding: 4px 4px 0;
}
.rate-card {
  background: #ffffff;
  border: 1px solid #e2e5ea;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(14, 23, 38, 0.04);
}
.rate-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 16px 20px;
}
.rate-card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #0e1726;
}
.rate-card-hint {
  font-size: 12px;
  color: #6c7688;
}
.rate-card-body {
  margin: 0 16px 16px;
  padding: 18px;
  background: #f1f3f7;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.rate-stars {
  display: flex;
  align-items: center;
  gap: 6px;
}
.rate-star {
  color: #c7ccd6;
  font-size: 28px;
  line-height: 1;
  display: inline-flex;
}
.rate-star.filled {
  color: #c9a14a;
}
.rate-val {
  margin-left: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #293958;
}
.rate-comment {
  width: 100%;
  min-height: 70px;
  border: 1px solid #e2e5ea;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  color: #0e1726;
  background: #ffffff;
  resize: vertical;
  font-family: inherit;
}
.styleText {
  font-weight: 900;
}
.my-select .vs__dropdown-toggle {
  padding: 12px 10px !important;
  border: none;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  background-color: #f7f7f7;
}
</style>
